var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,9.9c1.9,0,3.5-1.6,3.5-3.5c0-2.5-3.5-6.4-3.5-6.4S8.1,3.9,8.1,6.4C8.1,8.4,9.7,9.9,11.7,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,3.9C5.4,2.4,3.3,0,3.3,0S1.1,2.4,1.1,3.9c0,1.2,1,2.1,2.1,2.1S5.4,5.1,5.4,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,2.8V2.5c0-0.9-0.8-1.7-1.7-1.7c-1,0-1.7,0.8-1.7,1.7v0.2c-2.7,0.2-5.2,0.9-7.5,1.9c0.2,0.6,0.3,1.2,0.3,1.7c0,3-2.4,5.4-5.4,5.4c-1.1,0-2.2-0.3-3.1-0.9c-3.3,3.9-5.3,8.9-5.3,14.4c0.1-3.1,2.6-5.6,5.7-5.6c3.1,0,5.7,2.5,5.7,5.7c0-3.1,2.5-5.7,5.7-5.7c1.2,0,2.3,0.4,3.2,1v22.6c0,3.6,2.9,6.6,6.5,6.7l0.2,0v0c3.6-0.1,6.5-3,6.5-6.7c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8V20.8c0.9-0.7,2.1-1.1,3.3-1.1c3.1,0,5.7,2.5,5.7,5.7c0-3.1,2.6-5.7,5.7-5.7c3.1,0,5.7,2.5,5.7,5.7c0,0,0,0.1,0,0.1C48.9,13.5,39.6,3.7,27.8,2.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLiability);
export default __webpack_public_path__ + "static/media/product-liability.2e9aa4921a3a243a93a4a6be9210abcc.svg";
export { ForwardRef as ReactComponent };